type Event = {
	eventName: string;
};

export enum FREQUENCYTYPE {
	MINUTES = 'minutes',
	HOURLY = 'hourly',
	DAILY = 'daily',
	WEEKLY = 'weekly',
	MONTHLY = 'monthly',
	YEARLY = 'yearly',
}
export interface ISchedulerCronDetails {
	frequencyType: string;
	frequency?: number;
	startsAtHour?: number;
	startsAtMinutes?: number;
	startsAtSeconds?: number;
	skipWeekend?: boolean;
	days?: string;
	dayOfMonth?: number;
	dayOfWeek?: string;
	weekOfMonth?: number;
	monthOfYear?: number;
}

export interface IJobSchedulerRequest {
	jobName: string;
	jobDescription?: string;
	createdBy: string;
	updatedBy: string;
	eventName: string;
	eventPayload?: any;
	schedulerCronDetails: ISchedulerCronDetails;
}

export interface IJobSchedulerSuccessResponse {
	jobId: number;
	jobName: string;
	jobType: string;
}

export interface IJobSchedulerErrorResponse {
	errorCode: number;
	errorMessage?: string;
	timestamp?: string;
}

export interface IGetEventsRequest {
	status: string;
}

export interface IGetEventsResponse {
	currentPageNumber: number;
	numberOfRecordsPerPage: number;
	totalRecords: number;
	numberOfPages: number;
	events: Event[];
}

export interface IJobDetail {
	jobName: string;
	jobDescription: string;
	createdBy: string;
	updatedBy: string;
	eventName: string;
	eventPayload: object;
}

export interface IGetJobsResponse {
	jobId: string;
	jobInstanceCount: number;
	jobType: string;
	cronExpr: string;
	jobDetail: IJobDetail;
}
